import { IconButton } from "@mui/material";
import { useAnalitycs } from "hooks/useAnalytics";
import { ReactComponent as DownloadIcon } from "images/file-csv.svg";
import { LineChart } from "./LineChart";
import { SubtotalNqrTable } from "./SubtotalNqrTable";
import { SubtotalTable } from "./SubtotalTable";
import { TotalFields } from "./TotalFields";
import { LocationAnalyticsFilter } from "./LocationAnalyticsFilter";

export const LocationAnalitycs = () => {
  const {
    loading,
    setLoading,
    setFilter,
    data,
    setData,
    totalData,
    setTotalData,
    subtotalData,
    setSubtotalData,
    subtotalNqrData,
    setSubtotalNqrData,
    itemName,
    setItemName,
    period,
    setPeriod,
    handleDownload,
  } = useAnalitycs();

  return (
    <>
      <LocationAnalyticsFilter
        isLoading={loading}
        setData={setData}
        setLoading={setLoading}
        setTotalData={setTotalData}
        setSubtotalData={setSubtotalData}
        setSubtotalNqrData={setSubtotalNqrData}
        setItemName={setItemName}
        setPeriod={setPeriod}
        setFilter={setFilter}
        icon={
          <IconButton onClick={handleDownload} disabled={loading}>
            <DownloadIcon width={"32px"} />
          </IconButton>
        }
      />
      <TotalFields totalData={totalData} itemName={itemName} />
      <div
        className={`
                flex-1 flex-shrink-0 flex flex-col justify-start items-stretch gap-4
                rounded-2xl p-4 bg-white shadow-sm mt-4
            `}
      >
        <LineChart loading={loading} data={data} period={period} />
        <SubtotalNqrTable subtotalData={subtotalNqrData} itemName={itemName} />
        <SubtotalTable subtotalData={subtotalData} itemName={itemName} />
      </div>
    </>
  );
};
